import type { FaireProductEntity } from "../../entity_types/product";

export const p_mjun79a8ny: FaireProductEntity = {
  token: "p_mjun79a8ny",
  type: "product",
  name: "Mo&Co Home Exclusive: Sculpted Beeswax Trees | 2 Sizes",
  brandToken: "b_94ned2lnmo",
  brandName: "Mo&Co Home",
  imageUrl:
    "https://cdn.faire.com/fastly/8b9fc6ed828c9daad1503ba1086edec9e30c6fce43a63ecf1ec9ed6a8ac83014.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2d114bacdf5c4c0e04cb0651e35e8f8da04c1613864129ea2700334212476ee3.jpeg",
    "https://cdn.faire.com/fastly/de438461b3205a385cec26b9b51038c10828d7cd01b4d92ea8f513063d14b197.jpeg",
    "https://cdn.faire.com/fastly/70227a1e81985c6993a8a9d415eae438bc840d6dcdc4aca0da3dfe268acabb1b.jpeg",
    "https://cdn.faire.com/fastly/c03520ecb1b0b52c8a4eb0bd7599263778c7dea4c961224751e67efe3c0969ed.jpeg",
    "https://cdn.faire.com/fastly/b73f89429437002b64692ab2a00315c57ce2f9dcbae8d69fd2b864d05fb5f71b.jpeg",
    "https://cdn.faire.com/fastly/2197640fb45a8a8f5402b5e5a2973134b7f494733aebae3e28ddf9a4dc9a02f4.jpeg",
    "https://cdn.faire.com/fastly/824d6a1180aebd37f5d4dabf3d6664294bb09cf875fad96e5ec9ab0a206fb625.jpeg",
    "https://cdn.faire.com/fastly/5aa1ac85fa107b6b2b78fd7632c9ba5fcea1e0dfd901b325ae4791cbe0f46362.jpeg",
  ],
  priceDollars: 9,
  description:
    'These Mo&Co Home exclusive, hand-poured 100% beeswax candles are inspired by vintage mercury glass ornaments, fractal geometry, and the delicate artistry of piped royal icing. Designed to evoke holiday nostalgia with a refined, contemporary style, they bring warmth, elegance, and a sculptural touch to seasonal gatherings and holiday gifting.\n\nOur in-studio sculptor, Carrie, designed these one of a kind tree candles. The creation began with a custom digital design followed by a hand-refined 3D-printed model. Our candlemakers then crafted the molds and hand-poured each candle in pure beeswax. Through thoughtful craftsmanship, these candles are the union of artistry and exceptional quality.\n\n𝗜𝗻𝗴𝗿𝗲𝗱𝗶𝗲𝗻𝘁𝘀:\n• 100% Beeswax\n• Cotton Wick\n• Eco-conscious coloring\n\nAvailable in 2 sizes\nSmall\n• Height: 2 5/8"\n• Diameter: 2 5/16"\n\nLarge\n• Height: 3 7/8"\n• Diameter: 3 3/8"\n\nSold Individually',
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:27.008Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
